import { render, staticRenderFns } from "./AdminLinksList.vue?vue&type=template&id=5a48a750&scoped=true&"
import script from "./AdminLinksList.vue?vue&type=script&lang=js&"
export * from "./AdminLinksList.vue?vue&type=script&lang=js&"
import style0 from "./AdminLinksList.vue?vue&type=style&index=0&id=5a48a750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48a750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a48a750')) {
      api.createRecord('5a48a750', component.options)
    } else {
      api.reload('5a48a750', component.options)
    }
    module.hot.accept("./AdminLinksList.vue?vue&type=template&id=5a48a750&scoped=true&", function () {
      api.rerender('5a48a750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminLinksList.vue"
export default component.exports